import STATUS from '../status';
export default {
  name: 'ImportSection',
  props: {
    status: Number,
    root: Object,
    color: String
  },
  data: () => ({
    importedNum: 0
  }),
  computed: {
    isWaiting() {
      return this.status <= STATUS.UPLOAD_FAILED;
    },

    isImporting() {
      return this.status === STATUS.IMPORTING;
    },

    isComplete() {
      return this.status === STATUS.IMPORT_SUCCESS;
    },

    isFailed() {
      return this.status === STATUS.IMPORT_FAILED;
    }

  },
  methods: {
    async doImport(res) {
      this.$emit('status-change', STATUS.IMPORTING);

      try {
        let result = await this.root.$applyPluginsAsyncWaterfall('rownum', res);

        if (result && result.rownum) {
          this.importedNum = result.rownum;
        }

        result = await this.root.$applyPluginsAsyncWaterfall('import', res);

        if (result) {
          // do async import
          this.$emit('status-change', STATUS.IMPORT_SUCCESS);
          this.$emit('imported', result);
        } else {
          this.$message({
            message: '导入失败',
            type: 'error'
          });
          this.$emit('status-change', STATUS.IMPORT_FAILED);
        }
      } catch (e) {
        console.error(e);
        this.$message({
          message: '导入失败',
          type: 'error'
        });
      }
    }

  }
};